import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FormManagerService {
  private forms: Map<string, FormGroup>;

  constructor() {
    this.forms = new Map<string, FormGroup>();
  }

  get valid(): boolean {
    let result = true;
    this.forms.forEach((formGroup: FormGroup) => {
      if (!formGroup.valid) {
        result = false;
      }
    });
    return result;
  }

  addForm(name: string, form: FormGroup): void {
    if (!form) {
      return;
    }
    if (!name || name.length === 0) {
      return;
    }
    this.forms.set(name, form);
  }
}
